// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ydij2","checkboxCol":"Table_checkboxCol__3sXrj","emailCol":"Table_emailCol__3uKI-","actionCol":"Table_actionCol__1wnNB"};